import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyTransporterMaster = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({ url: 'transporterMaster' })
            .then((result) => {
                if(props.vendorOwnershipFilter){
                    let vendorData = result.data.resultSet, tempown = []
                    for (let index = 0; index < vendorData.length; index++) {
                        if (
                          vendorData[index].vendorOwnershipType == 0 ||
                          vendorData[index].vendorOwnershipType == null
                        ) {
                          tempown.push(vendorData[index]);
                        }
                      }
                      setcontent(tempown)
                }else{
                    setcontent(result.data.resultSet)
                }
                setloading(false)
            })
    }, [])

    const handleSearch = (e, data) => {
        setloading(true)
        let searchTerm = data.searchQuery
        ReadAxios({ url: 'transporterMaster', readItems: { searchTerm: searchTerm } })
            .then((result) => {
                if(props.vendorOwnershipFilter){
                    let vendorData = result.data.resultSet, tempown = []
                    for (let index = 0; index < vendorData.length; index++) {
                        if (
                          vendorData[index].vendorOwnershipType == 0 ||
                          vendorData[index].vendorOwnershipType == null
                        ) {
                          tempown.push(vendorData[index]);
                        }
                      }
                      setcontent(tempown)
                }else{
                    setcontent(result.data.resultSet)
                }
                setloading(false)
            })
    }
    let options = []
    if (content?.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.transporterMasterId
            temp.text = `${object.transporterName}  (${object.transporterCode})`
            temp.value = props.IdValue? object.transporterMasterId : object.transporterName
            temp.extra = object
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)  
        let extraDetails 
        if(data.options) {
            extraDetails = data.options.find((option)=>option.value===data.value)?.extra
        }
        if(props.gst && extraDetails?.companyGst) setFieldValue(props.gst, extraDetails?.companyGst)     
    }


    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={props.onChange ? props.onChange : handleChange}
            options={options}
            clearable
            onSearchChange={handleSearch}
            {...props}
        />
    )
}

export default MyTransporterMaster